module.exports = __webpack_public_path__ + "img/away.d73b40b7.png";